var _rect, _path, _path2, _rect2, _rect3, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSftpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 25,
    width: 6,
    height: 2,
    rx: 1,
    transform: "rotate(-90 13 25)",
    fill: "#98A2B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5C4 3.89543 4.89543 3 6 3H10.2671C11.3727 3 12.429 3.45763 13.1852 4.26424L13.2824 4.36788C13.6605 4.77118 14.1886 5 14.7415 5H16H21H22C23.1046 5 24 5.89543 24 7V14C24 15.1046 23.1046 16 22 16H6C4.89543 16 4 15.1046 4 14V5Z",
    fill: "#FEC84B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16565 10.1534C3.07629 8.99181 3.99473 8 5.15975 8H22.8402C24.0053 8 24.9237 8.9918 24.8344 10.1534L24.142 19.1534C24.0619 20.1954 23.193 21 22.1479 21H5.85206C4.80699 21 3.93811 20.1954 3.85795 19.1534L3.16565 10.1534Z",
    fill: "#F79009"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 23,
    width: 22,
    height: 2,
    rx: 1,
    fill: "#98A2B3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 26,
    width: 4,
    height: 4,
    rx: 2,
    transform: "rotate(-90 12 26)",
    fill: "#DD6A6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 11.6666C18.3333 10.5621 19.2287 9.66663 20.3333 9.66663H27.5L29.1666 12.1666L31.6666 15.5V24.3333C31.6666 25.4379 30.7712 26.3333 29.6666 26.3333H20.3333C19.2287 26.3333 18.3333 25.4379 18.3333 24.3333V11.6666Z",
    fill: "#EAECF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 15.5H31.6667L27.5 9.66667V13.5C27.5 14.6046 28.3955 15.5 29.5 15.5Z",
    fill: "#AFB5D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.01 20.1792C27.7778 20.1559 27.5461 20.1081 27.3139 19.9892C27.5222 19.9475 27.7066 19.9475 27.915 19.9475C28.3789 19.9475 28.4683 20.0603 28.4683 20.132C28.3316 20.1792 28.1705 20.1975 28.01 20.1792ZM25.6478 19.8759C25.1422 19.9892 24.5822 20.1559 24.0766 20.3403V20.2925L24.0289 20.3164C24.2844 19.8048 24.5172 19.2748 24.725 18.7392L24.7433 18.7631L24.7666 18.7214C25.0228 19.1142 25.35 19.507 25.695 19.852H25.6239L25.6478 19.8759ZM24.4455 15.3892C24.4694 15.3653 24.5172 15.3653 24.5344 15.3653H24.6066C24.7296 15.758 24.7211 16.1802 24.5822 16.5675C24.4216 16.1981 24.3505 15.782 24.4455 15.3892ZM21.6011 22.2803L21.5294 22.3042C21.7366 22.0045 22.026 21.7711 22.3628 21.632C22.1783 21.9348 21.9222 22.167 21.6011 22.2803ZM27.9389 19.2509C27.4505 19.2509 26.9689 19.3225 26.4805 19.412C25.9006 18.8811 25.4157 18.2551 25.0466 17.5609C25.4394 16.2637 25.4633 15.3887 25.1594 14.972C25.0889 14.8792 24.9982 14.8037 24.8941 14.7512C24.7901 14.6988 24.6754 14.6707 24.5589 14.6692C24.2611 14.6453 23.9811 14.7881 23.8444 15.0381C23.4278 15.7342 24.0289 17.097 24.3089 17.6564C23.9811 18.6503 23.5889 19.5964 23.0766 20.5248C20.8811 21.4709 20.8333 22.0481 20.8333 22.2564C20.8333 22.512 20.9761 22.7681 21.2261 22.8814C21.3211 22.9525 21.4583 22.9759 21.5772 22.9759C22.155 22.9759 22.8272 22.3275 23.5411 21.0542C24.4455 20.6853 25.35 20.3875 26.2966 20.1792C26.7811 20.5835 27.3806 20.8251 28.01 20.8698C28.4028 20.8698 29.1644 20.8698 29.1644 20.0842C29.1883 19.7809 29.0278 19.2748 27.9389 19.2509Z",
    fill: "#D92D20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSftpLogo);
export default __webpack_public_path__ + "static/media/sftp-logo.6fcc2e6d4abe3efac645b59799f8e564.svg";
export { ForwardRef as ReactComponent };